import { useMemo } from "react";
import { useRouter } from "../../store/router";
import { useBoothConfig } from "../../store/booth";
import { useOutputPlan } from "../../hooks/useStyles";
import { printSheetCss, resolvePrintPreset } from "./printSheetCss";

/**
 * 인쇄 시트 — `.app` 의 형제로 렌더된다. 화면에서는 숨기고(#print-sheet { display: none })
 * @media print 에서만 결과 사진 한 장을 **부스 프린터 용지**에 활성 인쇄 프리셋의 사진 mm 로 배치한다 (BOOTH-57).
 * 사진 규격은 전역 프리셋, 용지는 부스(`booth.paperMm`, 없으면 용지 = 사진) — 프린터가 부스마다 달라서다.
 * 시트 치수·여백·회전은 이 두 값에서 유도되므로 정적 CSS 가 아니라 여기서 <style> 로 함께 렌더한다.
 * PrintView 가 이 img 의 decode 를 기다린 뒤 window.print().
 */
export function PrintSheet() {
  const src = useRouter((s) => s.capturedShots[0]?.transformedDataUrl ?? s.capturedShots[0]?.dataUrl ?? null);
  const plan = useOutputPlan();
  const preset = resolvePrintPreset(plan);
  const paper = useBoothConfig((s) => s.config?.booth.paperMm ?? null);
  const css = useMemo(() => printSheetCss(preset, paper), [preset, paper]);
  if (!src) return null;
  return (
    <>
      <style>{css}</style>
      <div id="print-sheet" aria-hidden>
        <img id="print-sheet-img" src={src} alt="" />
      </div>
    </>
  );
}
